import React from 'react';

export const NONE_ENTERED = "None entered";
//Presentational component that displays 'None entered' 
//Having this as a component allows us to return <NoneEntered /> conditionally
//from other presentational components like <StarRating>
//But yeah basically it's just returning a constant string, but as a JSX component.
export function NothingEntered(){
  let noneLabel = NONE_ENTERED;
  return(
    <>
      {noneLabel}
    </>
  );
}

export function UserTextOrNone(props){
  if (props.userText){
    return(<>{props.userText}</>);
  }
  else return <NothingEntered />;
}

